export default {
    getChamados: state => state.chamados,
    getConversa: state => state.conversa,
    getGruposPxTalk: state => state.grupos,
    getTaxistas: state => state.taxistas,
    getAgentes: state => state.agentes,
    getIdGpAgentes: state => state.grupo_agentes,
	getIdGpTaxistas: state => state.grupo_taxistas,
    getAppId: state => state.dash_id,
    /*getAgentes: state => {
        state.chamados
    }*/
}



// WEBPACK FOOTER //
// ./src/store/modules/pxtalk/getters.js